var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeic = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 7C13 7 12 6 12 4V1H6C4 1 3 2 3 4V16C3 18 4 19 6 19H15C17 19 18 18 18 16V7H15Z",
    fill: "#4D6EF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H18L12 1V4C12 6 13 7 15 7Z",
    fill: "#4D6EF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5273 11.4902V15.0002H7.6723V13.5552H6.3423V15.0002H5.4873V11.4902H6.3423V12.8652H7.6723V11.4902H8.5273Z",
    fill: "#4D6EF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99953 12.1752V12.8852H11.1445V13.5452H9.99953V14.3152H11.2945V15.0002H9.14453V11.4902H11.2945V12.1752H9.99953Z",
    fill: "#4D6EF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7046 11.4902V15.0002H11.8496V11.4902H12.7046Z",
    fill: "#4D6EF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1792 13.2402C13.1792 12.8935 13.2542 12.5852 13.4042 12.3152C13.5542 12.0419 13.7626 11.8302 14.0292 11.6802C14.2992 11.5269 14.6042 11.4502 14.9442 11.4502C15.3609 11.4502 15.7176 11.5602 16.0142 11.7802C16.3109 12.0002 16.5092 12.3002 16.6092 12.6802H15.6692C15.5992 12.5335 15.4992 12.4219 15.3692 12.3452C15.2426 12.2685 15.0976 12.2302 14.9342 12.2302C14.6709 12.2302 14.4576 12.3219 14.2942 12.5052C14.1309 12.6885 14.0492 12.9335 14.0492 13.2402C14.0492 13.5469 14.1309 13.7919 14.2942 13.9752C14.4576 14.1585 14.6709 14.2502 14.9342 14.2502C15.0976 14.2502 15.2426 14.2119 15.3692 14.1352C15.4992 14.0585 15.5992 13.9469 15.6692 13.8002H16.6092C16.5092 14.1802 16.3109 14.4802 16.0142 14.7002C15.7176 14.9169 15.3609 15.0252 14.9442 15.0252C14.6042 15.0252 14.2992 14.9502 14.0292 14.8002C13.7626 14.6469 13.5542 14.4352 13.4042 14.1652C13.2542 13.8952 13.1792 13.5869 13.1792 13.2402Z",
    fill: "#4D6EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeic);
export default ForwardRef;